(function (Drupal, $) {
  'use strict';
  Drupal.behaviors.preview_donation = {
    attach: function (context, settings) {

      var pdfjsLib;

      if ($(context).is('.donation-certificate-preview, .webform-submission-donation-company-form, .webform-submission-donation-form, .webform-submission-donation-product-form')
        || $('.donation-certificate-preview', context).length
        || $('.webform-submission-donation-product-form', context).length
        || ($(context).is('.webform-submission-form') && $('div[data-drupal-selector="donations-form-preview"]', context).length)
        || $('.webform-submission-form div[data-drupal-selector="donations-form-preview"]', context).length
      ) {
        var base_path = 'https://cdnjs.cloudflare.com/ajax/libs/pdf.js/2.2.228/';

        var script = document.createElement('script');
        script.src = base_path + 'pdf.min.js';
        script.addEventListener('load', function () {
          pdfjsLib = window['pdfjs-dist/build/pdf'];
          pdfjsLib.GlobalWorkerOptions.workerSrc = base_path + 'pdf.worker.min.js';

          attach_cart_previews();
        });
        document.head.appendChild(script);
      }

      // https://mozilla.github.io/pdf.js/examples/index.html#interactive-examples

      $('.webform-submission-donation-form, .webform-submission-donation-company-form, .webform-submission-donation-product-form', context.parentElement)
        .has('div[data-drupal-selector="edit-customize"]')
        .once('preview_donation').each(function () {
          var form = this;

          var preview_button = document.createElement('button');
          preview_button.textContent = 'Förhandsgranska';
          preview_button.classList.add('button', 'cta', 'white');
          form.querySelector('div[data-drupal-selector="edit-actions"]').prepend(preview_button);

          var cover = document.createElement('div');
          cover.classList.add('preview-cover');
          cover.classList.add('preview-cover--hidden');
          form.appendChild(cover);

          var container = document.createElement('div');
          container.classList.add('preview-container');
          container.classList.add('preview-container--hidden');
          cover.appendChild(container);

          var canvas = document.createElement('canvas');
          canvas.classList.add('preview-canvas');
          canvas.classList.add('preview-canvas--hidden');
          container.appendChild(canvas);

          preview_button.addEventListener('click', function (e) {
            e.preventDefault();

            cover.classList.remove('preview-cover--hidden');
            container.classList.remove('preview-container--hidden');

            $.post('/donations/certificate', $(form).serialize())
              .done(function (url) {
                render_pdf(url, canvas, 2.0)
                  .then(function () {
                    canvas.classList.remove('preview-canvas--hidden');
                  });
              });
          });

          cover.addEventListener('click', function (e) {
            cover.classList.add('preview-cover--hidden');
            container.classList.add('preview-container--hidden');
            canvas.classList.add('preview-canvas--hidden');
          });
        });

      $('.webform-submission-form', context.parentElement)
        .has('div[data-drupal-selector="donations-form-preview"]')
        .once('preview_donation').each(function () {
          var form = this;

          var preview_link = document.createElement('a');
          preview_link.href = '#';
          preview_link.title = 'Förhandsgranska';
          preview_link.text = 'Förhandsgranska';
          form.querySelector('div[data-drupal-selector="donations-form-preview"]').prepend(preview_link);

          var cover = document.createElement('div');
          cover.classList.add('preview-cover');
          cover.classList.add('preview-cover--hidden');
          form.appendChild(cover);

          var container = document.createElement('div');
          container.classList.add('preview-container');
          container.classList.add('preview-container--hidden');
          cover.appendChild(container);

          var canvas = document.createElement('canvas');
          canvas.classList.add('preview-canvas');
          canvas.classList.add('preview-canvas--hidden');
          container.appendChild(canvas);

          preview_link.addEventListener('click', function (e) {
            e.preventDefault();

            cover.classList.remove('preview-cover--hidden');
            container.classList.remove('preview-container--hidden');

            $.post('/donations/certificate', $(form).serialize())
              .done(function (url) {
                render_pdf(url, canvas, 2.0)
                  .then(function () {
                    canvas.classList.remove('preview-canvas--hidden');
                  });
              });
          });

          cover.addEventListener('click', function (e) {
            cover.classList.add('preview-cover--hidden');
            container.classList.add('preview-container--hidden');
            canvas.classList.add('preview-canvas--hidden');
          });
        });

      function attach_cart_previews() {
        $('.donation-certificate-preview').each(function () {
          var preview_url = $(this).find('a').attr('href');
          // console.log(url);
          var canvas_preview = document.createElement('canvas');
          canvas_preview.classList.add('canvas-preview');
          // canvas.style = 'width: 168px;';
          this.appendChild(canvas_preview);
          $(this).find('a').hide();
          render_pdf(preview_url, canvas_preview, 0.4);

          var cover = document.createElement('div');
          cover.classList.add('preview-cover');
          cover.classList.add('preview-cover--hidden');
          this.appendChild(cover);

          var container = document.createElement('div');
          container.classList.add('preview-container');
          container.classList.add('preview-container--hidden');
          cover.appendChild(container);

          var canvas = document.createElement('canvas');
          canvas.classList.add('preview-canvas');
          canvas.classList.add('preview-canvas--hidden');
          container.appendChild(canvas);

          canvas_preview.addEventListener('click', function (e) {
            e.preventDefault();

            cover.classList.remove('preview-cover--hidden');
            container.classList.remove('preview-container--hidden');

            render_pdf(preview_url, canvas, 2.0)
              .then(function () {
                canvas.classList.remove('preview-canvas--hidden');
              });
          });

          cover.addEventListener('click', function (e) {
            cover.classList.add('preview-cover--hidden');
            container.classList.add('preview-container--hidden');
            canvas.classList.add('preview-canvas--hidden');
          });
        });
      }

      function render_pdf(url, canvas, scale) {
        return window.pdfjsLib.getDocument(url)
          .promise
          .then(function (pdf) {
            console.log('PDF loaded');

            var pageNumber = 1;
            return pdf.getPage(pageNumber);
          })
          .then(function (page) {
            console.log('Page loaded');

            var viewport = page.getViewport(scale);

            // Prepare canvas using PDF page dimensions
            var context = canvas.getContext('2d');
            canvas.height = viewport.height;
            canvas.width = viewport.width;

            // Render PDF page into canvas context
            var renderContext = {
              canvasContext: context,
              viewport: viewport
            };

            return page.render(renderContext);
          })
          .then(function () {
            console.log('Page rendered');
          })
          .catch(function (error) {
            console.error(error);
          });
      }
    }
  }
}(Drupal, jQuery));
